//update 3102023
app.brasizecalculator = {
  underbustsizes: JSON.parse(app.preferences["BRA_UNDERBUSTSIZES"]),
  cups: JSON.parse(app.preferences["BRA_CUPSIZES"]),
  sloggichart: app.preferences["SLOGGI_CHART"],
  categoriesProductsDisplay: {
    group1: [
      //A or B Cup
      { cat: "wired-bras", filterDelim: "/", num: 2, sizeconversion: false },
      //,{cat:"bras/series__aqua",filterDelim:"+",num:1,sizeconversion:false}
      //,{cat:"sloggi-zero-feel",filterDelim:"/",num:1,sizeconversion:true} //
    ],

    group2: [
      //C cup or bigger
      { cat: "wired-bras", filterDelim: "/", num: 2, sizeconversion: false },
      //,{cat:"bras/series__aqua",filterDelim:"+",num:1,sizeconversion:false}
      //,{cat:"sloggi-zero-feel",filterDelim:"/",num:1,sizeconversion:true} //sloggi/series__sloggi-zero-feel
    ],
  },

  categoriesSelection: "bras-new,minimiser-bras,amourette-bras",

  productsPerCategories: 1,
  init: function () {
    this.initSliders();
    this.letsgetStarted();
    this.answeredQuestion();
    this.noMeasuringTape();
    this.sendForm();
    $("section").attr("data-ga-send", "false");

    $(document).on("click", ".update-bra-size-calculator", function (e) {
      e.preventDefault();
      location.reload();
      /*$(".braCalc section").removeClass("hide");
            $(".braCalc hr").removeClass("hide");
            $('.js-description-newsize').hide();
            $('.js-description-oldsize').hide();
            $("#completed-result").addClass("hide")
            window.scrollTo(0, 0);*/
    });
  },

  /*
   * Initialize the sliders for the band width and cup size
   */
  initSliders: function () {
    var isRangeBandSet = false;
    var isRangeCupSet = false;
    // define wether or not to use different values on slider elements (values, steps). Necessary for UK, FR and IT so far.
    var isAlternativeMeasurement = false;
    var isAlternativeMeasurementIT = false;
    var isAlternativeMeasurementFR = false;

    // slider for underbust size
    var underbustsizesMin = parseInt(this.underbustsizes[0].ausize);
    var underbustsizesMax = parseInt(
      this.underbustsizes[this.underbustsizes.length - 1].ausize
    );

    var startingValueBand = isAlternativeMeasurement ? 56 : 8;
    var underbustsizesStep = isAlternativeMeasurement ? 2 : 2;

    $(".rangeslider-band .slider").slider({
      min: underbustsizesMin,
      max: underbustsizesMax,
      range: "min",
      step: underbustsizesStep,
      value: startingValueBand,
      stop: function (event, ui) {
        bandwidth = localStorage.getItem("bandwidth");
        // if no bandwidth chosen, do nothing and therefore force the user to select something
        if (bandwidth != undefined) {
          isRangeBandSet = true;
          if (isRangeBandSet && isRangeCupSet) {
            var currentsection = $(".rangeslider-band").closest("section");

            //here ga
            if (currentsection.attr("data-ga-send") == "false") {
              currentsection.attr("data-ga-send", "true");
              if (typeof gtag != "undefined") {
                //ga('send', 'event', 'Bra Size Calculator', 'Slide', (currentsection.find("h2.headline-large").text()).toLowerCase());
                gtag("event", "Slide", {
                  category: "Bra Size Calculator",
                  label: currentsection
                    .find("h2.headline-large")
                    .text()
                    .toLowerCase(),
                });
              }
            }

            var nextStep = $('label[data-step="1"]').eq(0).closest("section");
            app.brasizecalculator.moveOnToNextSection(nextStep);
          }
        } else {
          return false;
        }
      },
      create: function (event, ui) {
        $(".rangeslider-band .ui-slider-handle").attr("data-value", "--");
      },
      slide: function (event, ui) {
        $(".rangeslider-band .ui-slider-handle").attr("data-value", ui.value);
        localStorage.setItem("bandwidth", ui.value); // save the value in the local storage
      },
    });

    // slider for cupsize
    var startingValueCup = 0;
    $(".rangeslider-cup .slider").slider({
      min: 0,
      max: app.brasizecalculator.cups.length - 1,
      step: 1,
      range: "min",
      value: startingValueCup,
      stop: function (event, ui) {
        cupsize = localStorage.getItem("cupsize");
        // if no cupsize chosen, do nothing and therefore force the user to select something
        if (cupsize != undefined) {
          isRangeCupSet = true;
          if (isRangeBandSet && isRangeCupSet) {
            var currentsection = $(".rangeslider-cup").closest("section");

            if (currentsection.attr("data-ga-send") == "false") {
              currentsection.attr("data-ga-send", "true");
              if (typeof gtag != "undefined") {
                //ga('send', 'event', 'Bra Size Calculator', 'Slide', (currentsection.find("h2.headline-large").text()).toLowerCase());
                gtag("event", "Slide", {
                  category: "Bra Size Calculator",
                  label: currentsection
                    .find("h2.headline-large")
                    .text()
                    .toLowerCase(),
                });
              }
            }
            var nextStep = $('label[data-step="1"]').eq(0).closest("section");
            app.brasizecalculator.moveOnToNextSection(nextStep);
          }
        } else {
          return false;
        }
      },
      create: function (event, ui) {
        $(".rangeslider-cup .ui-slider-handle").attr("data-value", "--");
      },
      slide: function (event, ui) {
        $(".rangeslider-cup .ui-slider-handle").attr(
          "data-value",
          app.brasizecalculator.cups[ui.value]
        );
        localStorage.setItem("cupsize", app.brasizecalculator.cups[ui.value]); // save the value in the local storage
      },
    });

    // slider for underbust measuring (real measure by customer)
    var startingValueBandMeasured = 56;

    $(".rangeslider-measure .slider").slider({
      min: 56,
      max: 122,
      range: "min",
      value: startingValueBandMeasured,
      stop: function (event, ui) {
        var currentsection = $(".rangeslider-measure").closest("section");

        if (currentsection.attr("data-ga-send") == "false") {
          currentsection.attr("data-ga-send", "true");
          if (typeof gtag != "undefined") {
            //ga('send', 'event', 'Bra Size Calculator', 'Slide', (currentsection.find("h2.headline-large").text()).toLowerCase());
            gtag("event", "Slide", {
              category: "Bra Size Calculator",
              label: currentsection
                .find("h2.headline-large")
                .text()
                .toLowerCase(),
            });
          }
        }

        var nextStep = $('label[data-step="2"]').eq(0).closest("section");
        app.brasizecalculator.moveOnToNextSection(nextStep);

        if (localStorage.getItem("measurewidth") != null) {
          var measuredWidth = localStorage.getItem("measurewidth");

          // loop through the underbustsizes json and find the value in the array (range) and then return THAT related size value
          for (
            var i = 0;
            i < app.brasizecalculator.underbustsizes.length;
            i++
          ) {
            if (
              app.brasizecalculator.underbustsizes[i].range.indexOf(
                measuredWidth
              ) != -1
            ) {
              // now, we save the actual calculated underbust size for later use
              localStorage.setItem(
                "finalsize",
                app.brasizecalculator.underbustsizes[i].size
              ); // e.g. 90
              localStorage.setItem(
                "measurebandwidth",
                app.brasizecalculator.underbustsizes[i].size
              ); // e.g. 90
            }
          }
        }
      },
      create: function (event, ui) {
        $(".rangeslider-measure .ui-slider-handle").attr("data-value", "--");
      },
      slide: function (event, ui) {
        $(".rangeslider-measure .ui-slider-handle").attr(
          "data-value",
          ui.value
        );
        localStorage.setItem("measurewidth", ui.value); // save the value in the local storage
      },
    });
  },

  /*
   * "Let's get started" button in the intro section
   */
  letsgetStarted: function () {
    $(".js-getstarted")
      .unbind("click")
      .on("click", function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var firstStep = $(".rangeslider").eq(0).closest("section");
        var firstsection = $(this).closest("section");
        if (firstsection.attr("data-ga-send") == "false") {
          firstsection.attr("data-ga-send", "true");
          if (typeof gtag != "undefined") {
            //ga('send', 'event', 'Bra Size Calculator', 'Click', (firstStep.find("h2.headline-large").text()).toLowerCase());
            gtag("event", "Click", {
              category: "Bra Size Calculator",
              label: firstStep.find("h2.headline-large").text().toLowerCase(),
            });
          }
        }
        app.brasizecalculator.moveOnToNextSection(firstStep);
        //clean all localStorage value before to start a new calculation
        //localStorage.clear();
        app.brasizecalculator.clearLocalStorage();
        return false;
      });
  },

  clearLocalStorage: function () {
    localStorage.removeItem("cupsize");
    localStorage.removeItem("finalsize");
    localStorage.removeItem("bandwidth");
    localStorage.removeItem("measurebandwidth");
    localStorage.removeItem("measurewidth");
  },
  /*
   * Handling for answered questions
   */
  answeredQuestion: function () {
    $(".braCalc label")
      .unbind("click")
      .on("click", function (evt) {
        evt.stopPropagation();
        var currStep = parseInt($(this).attr("data-step"));
        if(1 == currStep && (true == $(".braCalc .nomeasuring").is(':checked'))){
          // don't move to next section if checkbox is unchecked
          $(".bandfeel").addClass("disabled");
          $(".cupsfeel").addClass("disabled");
          $('input[name="brasize-cups"]').prop('checked', false);
          $('input[name="brasize-band"]').prop('checked', false);
        }else{
        var currentSection = $(this).closest("section");
        if (currentSection.attr("data-ga-send") == "false") {
          currentSection.attr("data-ga-send", "true");
          if (typeof gtag != "undefined") {
            //ga('send', 'event', 'Bra Size Calculator', 'Click', (currentSection.find("h2.headline-large").text()).toLowerCase());
            gtag("event", "Click", {
              category: "Bra Size Calculator",
              label: currentSection
                .find("h2.headline-large")
                .text()
                .toLowerCase(),
            });
          }
        }

        var nextStep = $('label[data-step="' + (currStep + 1) + '"]')
          .eq(0)
          .closest("section");
        app.brasizecalculator.moveOnToNextSection(nextStep);
      }
      });
  },

  /*
   * Handling for not having a measuring tape
   */
  noMeasuringTape: function () {
    $(".braCalc .nomeasuring")
      .unbind("click")
      .on("click", function (evt) {
        evt.stopPropagation();
        if($(".braCalc .nomeasuring").is(':checked')){
        $(".howtomeasure .js-accordion-list-toggle").removeClass("is-active"); // close toggle
        //$(".howtomeasure").addClass("disabled"); // disable section

        var currentSection = $(this).closest("section");
        if (currentSection.attr("data-ga-send") == "false") {
          currentSection.attr("data-ga-send", "true");
          if (typeof gtag != "undefined") {
            //ga('send', 'event', 'Bra Size Calculator', 'Click', (currentSection.find("h2.headline-large").text()).toLowerCase());
            gtag("event", "Click", {
              category: "Bra Size Calculator",
              label: currentSection
                .find("h2.headline-large")
                .text()
                .toLowerCase(),
            });
          }
        }

        var nextStep = $('label[data-step="2"]').eq(0).closest("section");
        app.brasizecalculator.moveOnToNextSection(nextStep); // move to next step
      }
      });
  },
  /**
   * NS Added Function for AU Size Conversion
   */
  translateSize: function (searchsize) {
    var retSize = "";
    for (var i = 0; i < app.brasizecalculator.underbustsizes.length; i++) {
      if (
        app.brasizecalculator.underbustsizes[i]["size"].indexOf(searchsize) !=
        -1
      ) {
        retSize = app.brasizecalculator.underbustsizes[i].countrysize;
        break;
      }
    }
    return retSize;
  },
  /*
   * Scroll down to the next section and enable state (faked form)
   */
  sendForm: function () {
    $(".braCalc-result .see-result").click(function (e) {
      e.preventDefault();

      var answerCups = parseInt($('input[name="brasize-cups"]:checked').val());
      var answerBand = parseInt($('input[name="brasize-band"]:checked').val());
      var answerMeasurement = parseInt(
        $('input[name="no-measurement"]:checked').val()
      );

      if (answerCups !== 0) {
        var foundIndex = app.brasizecalculator.cups.indexOf(
          localStorage.getItem("cupsize")
        );
        var newIndex = foundIndex + answerCups;
        if (newIndex >= 0 && newIndex < app.brasizecalculator.cups.length) {
          localStorage.setItem("cupsize", app.brasizecalculator.cups[newIndex]);
        }
      }
      //console.log("answerMeasurement: " + answerMeasurement)
      // if the customer has no measuring tape, we use the bandwidth of the current bra
      if (answerMeasurement == 1) {
        var multiplier = 5;

        localStorage.setItem(
          "finalsize",
          parseInt(localStorage.getItem("bandwidth")) + answerBand * multiplier
        );
      } else {
        //console.log("answerBand: " + answerBand)
        // if the customer has a measuring tape and measured, we use the finalsize calculated by the function in line 95
        if (answerBand !== 0) {
          localStorage.setItem(
            "finalsize",
            parseInt(localStorage.getItem("finalsize"))
          );
        }
      }
      // save the finalsize in the localStorage
      //Original: localStorage.setItem("finalsize", localStorage.getItem("finalsize") + localStorage.getItem("cupsize"));
      if (1 == answerMeasurement) {
        localStorage.setItem(
          "finalsize",
          localStorage.getItem("finalsize") + localStorage.getItem("cupsize")
        );
      } else {
        var countrySize = app.brasizecalculator.translateSize(
          localStorage.getItem("finalsize")
        );
        localStorage.setItem(
          "finalsize",
          countrySize + localStorage.getItem("cupsize")
        );
      }

      $(".braCalc section").addClass("hide");
      $(".braCalc hr").addClass("hide");

      var finalwidth = localStorage.getItem("finalsize").match(/\d+/)[0];
      var finalcupsize = localStorage.getItem("finalsize").match(/[a-zA-Z]+/g);
      $("#completed-result").removeClass("hide");
      //check which message to show: about correct size or wrong size
      if (
        localStorage.getItem("bandwidth") !==
          localStorage.getItem("measurebandwidth") &&
        finalwidth != localStorage.getItem("bandwidth")
      ) {
        $(".js-description-newsize").show();
      } else {
        $(".js-description-oldsize").show();
      }

      //Show  email form?

      var getDataFormType = $("#completed-result").attr(
        "data-newsletter-form-type"
      );

      if (getDataFormType == "rejoiner") {
        $("#brasCalcSubscribe").removeClass("hide");
      } else {
        $("#brasCalcSubscribe").addClass("hide");
      }

      if (localStorage.getItem("finalsize") !== "") {
        var fsize = localStorage
          .getItem("finalsize")
          .toLowerCase()
          .split(" ")
          .join("");
        //var finalSizeLink = "<a href='" +  + "'>" + localStorage.getItem("finalsize") + "</a>";

        $("#completed-result .braCalc-finalsize").html(
          localStorage.getItem("finalsize")
        );
        $("#completed-result .shop-now-size").attr(
          "href",
          "/collections/bras/size__" + fsize
        );

        //BVP commented for now
        //will be implemented post launvh
        //app.brasizecalculator.displayProductSelection(fsize);

        if (typeof gtag != "undefined") {
          //ga('send', 'event', 'Bra Size Calculator', 'Click', ($("#completed-result").find("h2.headline-large").text()).toLowerCase());
          gtag("event", "Click", {
            category: "Bra Size Calculator",
            label: $("#completed-result")
              .find("h2.headline-large")
              .text()
              .toLowerCase(),
          });
        }
      }
      window.scrollTo(0, 0);
    });
  },

  /**
   * Display Product Carousel based on final bra size result
   */
  displayProductSelection: function (fsize) {
    var filteredSize = "size__" + fsize;
    var cupSize = localStorage.getItem("cupsize").toLowerCase();

    if (cupSize == "a" || cupSize == "b") {
      var catgoriesArrayHandles =
        app.brasizecalculator.categoriesProductsDisplay.group1;
    } else {
      var catgoriesArrayHandles =
        app.brasizecalculator.categoriesProductsDisplay.group2;
    }

    $("#productSelectionsContainer").addClass("processing");
    $(".loader.productsselection").removeClass("hide");

    var ajaxes = [];
    //Push all ajax calls to an array
    for (var i = 0; i < catgoriesArrayHandles.length; i++) {
      if (catgoriesArrayHandles[i].sizeconversion == true) {
        if (app.brasizecalculator.convertSize(fsize) !== "") {
          var newFilteredSize =
            "size__" + app.brasizecalculator.convertSize(fsize);
          ajaxes.push(
            app.brasizecalculator.requestProducts(
              "/collections/" +
                catgoriesArrayHandles[i].cat +
                catgoriesArrayHandles[i].filterDelim +
                newFilteredSize,
              catgoriesArrayHandles[i].num
            )
          );
        }
      } else {
        ajaxes.push(
          app.brasizecalculator.requestProducts(
            "/collections/" +
              catgoriesArrayHandles[i].cat +
              catgoriesArrayHandles[i].filterDelim +
              filteredSize,
            catgoriesArrayHandles[i].num
          )
        );
      }
    }

    $.when.apply($, ajaxes).done(function () {
      console.log("initialising the slideshow");
      setTimeout(function () {
        /*if( $("#productSelectionsContainer").attr("data-handles") !==""){
                    $("#productSelectionsContainer").removeClass("hide");
                    $("#productSelectionsContainer").removeClass("processing").addClass("completed")
                    
                    $(".no-products-found").addClass("hide")
                    
                    
                }else{
                    $(".no-products-found").removeClass("hide")
                    $(".loader.productsselection").addClass("hide");
                }*/
      }, 5000);
    });
  },
  convertSize: function (psize) {
    var retSize = "";
    var finalwidth = psize.match(/\d+/)[0];
    var finalcupsize = psize.match(/[a-zA-Z]+/g);
    if (finalcupsize !== null && finalwidth !== null) {
      var arrSlogSize = app.brasizecalculator.sloggichart;
      for (var i = 0; i < arrSlogSize.length; i++) {
        if (
          parseInt(finalwidth) >= parseInt(arrSlogSize[i].underbustsizes.min) &&
          parseInt(finalwidth) <= parseInt(arrSlogSize[i].underbustsizes.max)
        ) {
          var selSize = arrSlogSize[i];

          var arrCups = selSize.cups;
          for (j = 0; j < arrCups.length; j++) {
            if (
              finalcupsize[0].toLowerCase() == arrCups[j].size.toLowerCase()
            ) {
              retSize = arrCups[j].value;
            }
          }
        }
      }
      //console.log(app.brasizecalculator.sloggichart);
    }
    return retSize.toLowerCase();
  },
  requestProducts: function (purl, numitems) {
    $.ajax({
      url: purl,
      type: "GET",
      success: function (data) {
        $html = $(data);
        var productItems = $html.find(".product-card");

        //Getting a Random Product
        if (productItems.length > 0) {
          for (var i = 0; i < numitems; i++) {
            var cloneOb = productItems.eq(i); //productItems.eq(Math.floor(Math.random() * productItems.length));//productItems.eq(i)
            //console.log(cloneOb)
            if (cloneOb.length > 0) {
              var getCurrentDataHandles = $("#productSelectionsContainer").attr(
                "data-handles"
              );
              var arrDataHandles = [];

              if (getCurrentDataHandles !== "") {
                arrDataHandles = getCurrentDataHandles.split(",");
              }
              arrDataHandles.push(
                cloneOb.find(".product-media").attr("data-handle")
              );
              $("#productSelectionsContainer").attr(
                "data-handles",
                arrDataHandles.toString()
              );
            }
          }
        }
      },
    });
  },

  /*
   * Scroll down to the next section and enable state
   */
  moveOnToNextSection: function (selector) {
    if (selector) {
      var scrollheight = $("#header-wrapper").height();

      setTimeout(function () {
        $("html, body").animate(
          { scrollTop: selector.offset().top - scrollheight },
          500,
          function () {
            selector.removeClass("disabled");
          }
        );
      }, 400);
      setTimeout(function () {
        app.brasizecalculator.initYoutubeVideo(selector);
      }, 900);
    }
  },

  /*
   * Scroll down to the next section and enable state
   */
  initYoutubeVideo: function (selector) {
    var $scope = selector.find(".js-braCalc-video");
    var currHeight = $scope.innerHeight();
    $scope.hide(); // prevents visual jumps

    //temporary comment
    $scope.after(
      '<iframe width="100%" height="100%" style="height: ' +
        currHeight +
        'px;" src="https://www.youtube-nocookie.com/embed/' +
        $scope.attr("data-iframsrc") +
        "?autoplay=1&loop=1&playlist=" +
        $scope.attr("data-iframsrc") +
        '&amp;rel=0&amp;controls=0&amp;showinfo=0&amp;mute=1&amp;cc_load_policy=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
    );
    $scope.remove(); // prevents double init
  },
};

// application initialization on dom ready
jQuery(document).ready(function () {
  app.brasizecalculator.init();
});
